import ProductDeletionModal from './ProductDeletionModal'

export default ProductDeletionModal
